import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { TailSpin } from 'react-loader-spinner';
import { ADD_PERM } from '../../Utils/constant';
import { store } from '../../services/service';
import { usePermStore } from '../../store/PermissionStore';
import { useRoleStore } from '../../store/RoleStore';

export const RolePermission = () => {
    const {
        register,
        handleSubmit, reset,
    } = useForm()
    const [isSubmit, setIsSubmit] = useState(false);
    const [role, setRole] = useState(null)
    const menuList = usePermStore();
    const roleListe = useRoleStore()

    const submit = (data) => {
        console.log(data);
        const newData = []
        const remove = []

        if (data?.listActionId !== false) {
            data?.listActionId?.map((item) => (
                newData.push(item)
            ))
        } else {
            data.listActionId = []
        }

        if (data?.listActionRetireId !== false) {
            data?.listActionRetireId?.map((item) => (
                newData.indexOf(item) === -1 ? remove.push(item) : []
            ))
        } else {
            data.listActionRetireId = []
        }

        data.listActionRetireId = remove;
        setIsSubmit(true)

        store(ADD_PERM, 'application/json', data).then((res) => {
            setIsSubmit(false);
            if (res.status === 200) {
                reset();
                menuList.getData(role)
                toast.success('Enregistrement éffectué avec succes')
            }

        }).catch((err) => {
            setIsSubmit(false)
            toast.error(err.response.data.donnee)
        })
    }

    useEffect(() => {
        roleListe.getData('page=0&param=&size=8')
    }, [])

    useEffect(() => {
        reset()
        menuList.getData(role)
    }, [role])

    return (
        <>
            <form onSubmit={handleSubmit(submit)} className='px-2'>
                <div className='my-8'>
                    <div className='items-center'>
                        <div className='mb-3'>
                            <p className='font-medium'>Profil utilisateur</p>
                            <p className='text-xs'>Selectionner un profil pour lequel on veut attribuer des permissions</p>
                        </div>
                        <hr />
                        <label htmlFor="" className='text-sm font-medium'>Role</label>
                        <div className='font-mtn mb-8'>
                            <select value={role} {...register('role')}
                                onChange={(e) => {
                                    setRole(e.target.value)
                                }}
                                className="select select-bordered w-full lg:w-96 h-10" >
                                <option selected>
                                    Selectionnez un role
                                </option>
                                {
                                    roleListe?.data?.data?.map((item) => (
                                        <option value={item?.id}>
                                            {item?.id.toLowerCase().replace(/role_/g, ' ')}
                                        </option>
                                    ))
                                }

                            </select>
                        </div>

                    </div>
                    <div className='mb-3'>
                        <div className='flex gap-3 font-medium'>
                            <p>Permissions</p>
                            {/* <span onClick={() => {

                            }} className='btn btn-xs bg-main'>tout cocher</span> */}
                        </div>
                        <p className='text-xs'>Les permission sont groupées par menu donc ce menu sera visible une fois coché</p>
                    </div>
                    <hr />
                    {
                        menuList?.data?.length !== 0 && menuList.loading === false ?
                            <div className='my-3'>
                                <div className='grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 '>
                                    {
                                        menuList?.data?.map((item, index) => (
                                            <div key={index} className=''>
                                                <p className='rounded mb-2 text-center text-sm font-mtn bg-slate-100'>{item?.sousMenu?.description}</p>
                                                <ul>
                                                    {
                                                        item?.actions?.map((action) => (
                                                            <li className='flex items-center my-1 gap-1'>
                                                                <input {...register('listActionId')} value={[action?.id]} type="checkbox" defaultChecked={action?.isAssocie === true ? true : false} className="checkbox checkbox-sm checkbox-warning" />
                                                                <input hidden {...register('listActionRetireId')} value={[action?.id]} type="checkbox" defaultChecked={action?.isAssocie} className="checkbox checkbox-sm checkbox-warning" />
                                                                <p className='text-xs text-gray-600'>{action?.description}</p>
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                            :
                            <div className='w-full my-4 flex items-center justify-center'>
                                <TailSpin
                                    height="40"
                                    width="40"
                                    color="#000"
                                    ariaLabel="tail-spin-loading"
                                    radius="2"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                    visible={menuList.loading}
                                />
                            </div>
                    }


                    <button type='submit'
                        disabled={isSubmit ? true : false}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            } btn `}
                    >
                        {!isSubmit ? "Enregistrer " : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>
                </div>

            </form>
        </>
    )
}
